import { AddTaskType, InstanceProps } from "./types";

class WindowOpen {
  originOpen?: any;
  addTask?: AddTaskType;

  constructor(props: InstanceProps) {
    this.addTask = props.addTask;
  }

  // 初始化
  init = (isInit?: boolean) => {
    const originOpen = window.open;
    this.originOpen = originOpen;
    const openFunc: any = (url?: string, name?: string, specs?: string) => {
      if (isInit) {
        // 添加标记
        this.addTask?.("markPoint", {}, "openWin");
      }
			return originOpen(url, name, specs);
    };
    window.open = openFunc;
  };
}

export default WindowOpen;